import { render, staticRenderFns } from "./OrderDiscountTotal.vue?vue&type=template&id=9b529b6a&"
import script from "./OrderDiscountTotal.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports